export default {"src":"/_next/static/media/icon-caption-generator.2e97a40a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};